import { render, staticRenderFns } from "./FringeBenefitsDetails.vue?vue&type=template&id=b7c25134&scoped=true"
import script from "./FringeBenefitsDetails.vue?vue&type=script&lang=js"
export * from "./FringeBenefitsDetails.vue?vue&type=script&lang=js"
import style0 from "./FringeBenefitsDetails.vue?vue&type=style&index=0&id=b7c25134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c25134",
  null
  
)

export default component.exports